import React from 'react';
import { Box, Divider, Text } from '@wix/design-system';
import { InfoLine } from '../InfoSection';
import { withTranslation } from '@wix/fe-essentials/i18n';
import { dateFormat, localDate, currencyFormat } from '../../../../core';
import { dateFormatter as getDateFormatter } from '@wix/crm-financial-formatters';
import get from 'lodash.get';
export const PaymentsSectionComponent = ({ t, invoice, primarySiteLocale, }) => {
    const { payments, currency, locale } = invoice;
    const dateFormatter = primarySiteLocale
        ? getDateFormatter(primarySiteLocale, false)
        : localDate(dateFormat({ locale }));
    const currencyFormatter = currencyFormat({
        locale,
        currency,
    });
    if (!payments || payments.length === 0) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { marginTop: "16px" },
            React.createElement(Divider, null)),
        React.createElement(InfoLine, { type: "heading", paddingTop: "24px", paddingBottom: "12px" }, t('price-quote.view.payments-received', { count: payments.length })),
        payments.map((payment) => {
            const amount = get(payment, ['amount', 'serializedValue'], 0);
            return (React.createElement(Box, { direction: "vertical", gap: "4px", paddingTop: "12px" },
                React.createElement(Text, { size: "small" }, currencyFormatter(amount)),
                React.createElement(Box, { direction: "horizontal", gap: "8px", height: "100%" },
                    payment?.date && (React.createElement(Text, { size: "small", secondary: true }, dateFormatter(new Date(payment.date)))),
                    React.createElement(Divider, { direction: "vertical" }),
                    React.createElement(Text, { size: "small", secondary: true }, payment?.type))));
        })));
};
const PaymentsSection = withTranslation(['invoice-view', 'locale-data'])(PaymentsSectionComponent);
export { PaymentsSection };
//# sourceMappingURL=PaymentsSection.js.map